module.exports = __webpack_public_path__ + "static/img/buddy_mini_pictgrid2_800x667.8a00566.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/buddy_mini_pictgrid2_800x667.jpg
// module id = 96PZ
// module chunks = 0